module.exports = __webpack_public_path__ + "assets/img/advantage-item3.8856c16a.png";